let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j0PWv")).then(() => parcelRequire('ks6TI'));